import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';
import { MedicamentoService } from '../../../services/medicamento.service';
import { AutorizadorService } from '../../../services/autorizador.service';
import { LaboratorioService } from '../../../services/laboratorio.service';
import { ProgramaService } from '../../../services/programa.service';

@Component({
    selector: 'app-lancamento-medicamento',
    templateUrl: './lancamento-medicamento.component.html',
    styleUrls: ['./lancamento-medicamento.component.css'],
    standalone: false
})
export class LancamentoMedicamentoComponent implements OnInit {
  medicamentoForm!: UntypedFormGroup;
  idmedicamento = null;
  dataMedicamentoAtt = [];
  programas: Array<{ label: string; value: string; }> = [];
  autorizadores: Array<{ label: string; value: string; }> = [];
  laboratorios: Array<{ label: string; value: string; }> = [];
  listOfControl: Array<{ id: number; desconto: string; obs_desconto: string; }> = [];

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private medicamentoService: MedicamentoService,
    private autorizadorService: AutorizadorService,
    private laboratorioService: LaboratorioService,
    private programaService: ProgramaService
  ) { 
   
    this.medicamentoForm = this.newFormMedicamento();
    this.route.params.subscribe(res => this.idmedicamento = res.idmedicamento);
  }

  filtrarProgramas = (control: UntypedFormControl) => {
  
    if (control.value > 0) {
      this.getProgramas(control.value);
    }

    return {};
  }

  newFormMedicamento() {
    return new UntypedFormGroup({
      idmedicamento: new UntypedFormControl(''),
      idprograma: new UntypedFormControl('', [Validators.required]),
      ean: new UntypedFormControl('', [Validators.required]),
      controlado: new UntypedFormControl(false),
      idautorizador: new UntypedFormControl('', [Validators.required, this.filtrarProgramas]),
      descricao: new UntypedFormControl('', [Validators.required]),
      idlaboratorio: new UntypedFormControl('', [Validators.required]),
      observacao: new UntypedFormControl(null),
      telefone: new UntypedFormControl(''),
      site: new UntypedFormControl(''),
    });
  }

  ngOnInit(): void {
    this.getAutorizadores();
    this.getLaboratorios();
    this.getProgramas('');
    if (this.idmedicamento !== undefined) {
     this.medicamentoService.detalhar(this.idmedicamento).subscribe((p: any) => {
        let item = p.data.medicamento;
        this.dataMedicamentoAtt = item;
        this.medicamentoForm.get('site').setValue(item.site);
        this.medicamentoForm.get('telefone').setValue(item.telefone);
        this.medicamentoForm.get('idmedicamento').setValue(item.idmedicamento);
        this.medicamentoForm.get('idprograma').setValue(item.idprograma);
        this.medicamentoForm.get('ean').setValue(item.ean);
        this.medicamentoForm.get('controlado').setValue(item.controlado);
        this.medicamentoForm.get('idautorizador').setValue(item.programa.idautorizador);
        this.medicamentoForm.get('descricao').setValue(item.descricao);
        this.medicamentoForm.get('idlaboratorio').setValue(item.idlaboratorio);
        this.medicamentoForm.get('observacao').setValue(item.observacao);
        var itemDesc = 0;
        item.descontos.forEach(value => {
          this.adicionarDesconto();
          this.medicamentoForm.get(`desconto${itemDesc}`).setValue(value.desconto);
          this.medicamentoForm.get(`obs_desconto${itemDesc}`).setValue(value.obs_desconto);
          itemDesc++;
        });
      });
    } else {
      this.medicamentoForm.reset();
      this.adicionarDesconto();
    }
  
  }

  getAutorizadores() {
    this.autorizadorService.all(1, '', 100).subscribe((u: any) => {
      u.data.autorizador.data.forEach(item => {
        if(item['ativo'] === 1){
          this.autorizadores.push({
            label: item['nome'],
            value: item['idautorizador']
          });
        }
        
      });
    });
  }

  getLaboratorios() {
    this.laboratorioService.all(1, '', 100).subscribe((u: any) => {
      u.data.laboratorio.data.forEach(item => {
        if(item['ativo'] === 1){
          this.laboratorios.push({
            label: item['descricao'],
            value: item['idlaboratorio']
          });
        }
        
      });
    });
  }

  adicionarDesconto(){
    const id = this.listOfControl.length > 0 ? this.listOfControl[this.listOfControl.length - 1].id + 1 : 0;

    const control = {
      id,
      desconto: `desconto${id}`,
      obs_desconto: `obs_desconto${id}`
    };
    const index = this.listOfControl.push(control);

    this.medicamentoForm.addControl(this.listOfControl[index - 1].desconto, new UntypedFormControl(''));
    this.medicamentoForm.addControl(this.listOfControl[index - 1].obs_desconto, new UntypedFormControl(null));
    return control;
  }

  onSubmit() {
    for (const i in this.medicamentoForm.controls) {
      this.medicamentoForm.controls[i].markAsDirty();
      this.medicamentoForm.controls[i].updateValueAndValidity();
    }
    console.log(this.medicamentoForm);
    if (this.medicamentoForm.valid) {
      let id = this.message.loading('Salvando cadastro...').messageId;
      if (this.idmedicamento !== undefined) {
        let dadosEdicao = this.medicamentoForm.value;

        this.medicamentoService.atualizar(dadosEdicao).subscribe((p: any) => {
          this.router.navigate(['/medicamento']);
          this.message.remove(id);
          this.message.success('O medicamento foi atualizado com SUCESSO!');
        });

      } else {
        this.medicamentoService.criar(this.medicamentoForm.value).subscribe((p: any) => {
          this.message.remove(id);
          this.router.navigate(['/medicamento']);
          this.message.success('O medicamento foi cadastrado com SUCESSO!');
        });
      }

    } else {
      for (const i in this.medicamentoForm.controls) {
        this.medicamentoForm.controls[i].markAsDirty();
        this.medicamentoForm.controls[i].updateValueAndValidity();
      }
    }
  
  }

  getProgramas(search = '') {
    this.programaService.all(1, search, 100).subscribe((u: any) => {
      this.programas = [];
      u.data.programa.data.forEach(item => {
        this.programas.push({
          label: item['nome'],
          value: item['idprograma']
        });
      });
    });
  }
}
